mtl.alloy.factory['twitter-share'] = (function($) {
	'use strict';

	return function(element, options) {

		var $element = $(element);
		var $href = (typeof $element.data('href') !== 'undefined') ? $element.data('href') : window.location;

		$element.on('click', function(){
			window.open('https://twitter.com/share?url='+$href+'&text='+$('h1').text() + ' from '+$('meta[property="og:site_name"]').attr('value'), "", "width=500,height=250");
		});

	};

}($));
